import { SubscriptionMode } from "src/constants/userDetails";

export function doesUserCountExceedAvailableLicenses(
    companyMode: string | undefined,
    availableLicenseCount: number,
    newUserCount: number
): boolean {
    return companyMode !== SubscriptionMode.DEMO && availableLicenseCount < newUserCount;
}
